import React from 'react'
import { LineWave } from 'react-loader-spinner'

export default function Loading() {
    return (
        <div className='my-5'>
                <LineWave
                    height="150"
                    width="150"
                    color="#0369e4cc"
                    wrapperStyle={{}}
                    wrapperClass="d-felx justify-content-center"
                    visible={true}
                    ariaLabel="line-wave-loading"
                />
        </div>
    )
}
